import * as React from "react";
import { IPricingCalculatorResponse } from "src/services/interfaces/calculator/IPricingCalculatorResponse";
export const PricingResultHeader = (props: { title: string, pricing: IPricingCalculatorResponse }) => (
  <>
    <div className="pricing-header">
      <span className="subtitle">{props.title}</span>
    </div>
    <div className="region-container">
      <div className="row">
        <span className="left description">Cálculo:</span>
        <span className={`right calculation-result ${props.pricing?.isRecalculateValid ? "valid" : "invalid"}`}>{props.pricing?.isRecalculateValid ? "Válido" : "Inválido"}</span>
      </div>
      {!props.pricing?.isRecalculateValid && (
        <div className="row">
          <span className="left description">Detalhe:</span>
          <span className="right error-message">{props.pricing?.message}</span>
        </div>
      )}
    </div>
  </>
)



// WEBPACK FOOTER //
// ./src/components/common/pricing-result/PricingResultHeader.tsx